export const CHANGE_LOGIN_MODAL_STATE = "CHANGE_LOGIN_MODAL_STATE";

export const CHANGE_LOGIN_STATE = "CHANGE_LOGIN_STATE";

export const SAVE_LOGGED_IN_USER_STATE = "SAVE_LOGGED_IN_USER_STATE";

export const CLEAR_LOGGED_IN_USER_STATE = "SAVE_LOGGED_IN_USER_STATE";

export const REHYDRATE = "REHYDRATE";
